// Re-export types and Supabase functions from @/lib/supabase for backward compatibility
export type {
  TalentProfile,
  ApplicationData,
  CompanyData,
  JobData,
  ApplicationsStatuses
} from "@/lib/supabase";

export {
  fetchTalentProfile,
  fetchApplicationData,
  fetchTalentProfileByApplication,
  fetchJobData,
  fetchCompanyData,
  updateApplicationStatus,
  updateApplicationInterviewStatus,
  updateApplicationInterviewDate,
  updateApplicationInterviewLink,
  cancelApplicationInterviewStatus,
  updateApplicationNotes,
  getProfilePictureUrl,
  getMockInterviewVideoUrl,
  deleteMockInterview,
  getChatThread
} from "@/lib/supabase";

import type {
  TalentProfile,
  ApplicationData,
  CompanyData
} from "@/lib/supabase";

/**
 * Combines application and talent profile data
 */
export function combineApplicationAndProfileData(
  application: ApplicationData,
  company: CompanyData,
  profile: TalentProfile
): any {
  return {
    ...profile,
    ...application,
    ...company,
    application_id: application.id,
    talent_id: profile.id,
    company_id: company.id,
    additional_languages: profile.additional_languages || []
  };
}

/**
 * Gets appropriate loading text based on route type
 * Note: This function should be called with translation context
 */
export function getLoadingTextKey(isTalentProfile: boolean): string {
  return isTalentProfile
    ? "messages.loading_profile"
    : "messages.loading_application";
}

/**
 * Gets appropriate tab label key based on route type
 * Note: This function should be called with translation context
 */
export function getStatusTabLabelKey(isTalentProfile: boolean): string {
  return isTalentProfile
    ? "navigation.profile_details"
    : "navigation.status_progress";
}

/**
 * Gets default active tab based on route type
 */
export function getDefaultActiveTab(isTalentProfile: boolean): string {
  return isTalentProfile ? "general" : "job";
}
